import { Avatar, Flex, Modal } from 'antd';
import { useCreateFlowMutation } from 'api/FlowAiApi';
import ChatComponent from 'components/Message/ChatComponent/ChatComponent';
import SpinComponent from 'components/Tool/SpinComponent/SpinComponent';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { closeModal, selectModalName } from 'store/modalSlice';
import { useAppDispatch } from 'store/store';
import chatBotIcon from 'assets/chat-bot-icon.svg';
import './AiAssistModalComponent.css';

export const AI_ASSIST_MODAL_NAME = 'AI_ASSIST_MODAL_NAME';

function AiAssistModalComponent() {
  const dispatch = useAppDispatch();
  const [chatId, setChatId] = useState<string | null>(null);

  const [createFlow, { isLoading: isLoadingCreate }] = useCreateFlowMutation();

  const initAiAssistant = useCallback(async () => {
    try {
      const { id } = await createFlow().unwrap();
      setChatId(id);
    } catch (e) {
      console.error(e);
    }
  }, [createFlow]);

  useEffect(() => {
    void initAiAssistant();
  }, [initAiAssistant]);

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <Modal
      open={true}
      title={
        <Flex className="ai-assist-modal-component-title" align="center" gap={20}>
          <Avatar size={48} src={chatBotIcon} className="title-avatar" shape="square" /> Interview Assistant
        </Flex>
      }
      onCancel={handleCloseModal}
      closable={true}
      maskClosable={false}
      keyboard={false}
      footer={null}
      className="size-lg"
    >
      <div className="ai-assist-modal-component-divider" />
      <SpinComponent isLoading={isLoadingCreate}>
        <div className="ai-assist-modal-component">
          <ChatComponent chatId={chatId} onExit={handleCloseModal} />
        </div>
      </SpinComponent>
    </Modal>
  );
}

function AiAssistModalComponentWrapper() {
  const modalName = useSelector(selectModalName);

  return modalName === AI_ASSIST_MODAL_NAME ? <AiAssistModalComponent /> : null;
}

export default AiAssistModalComponentWrapper;
